import { mapToBreakpoints } from './mapToBreakpoints.js';

const getVisibilityStyle = values => {
  return mapToBreakpoints(values, value => {
    if (!value) {
      return 'display: none;';
    } else {
      return 'display: block;';
    }
  });
};

export { getVisibilityStyle };
//# sourceMappingURL=getVisibilityStyle.js.map
